// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:GLOBAL:NAV
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:community/view/util/dropdown_button': 'DropdownButton',
  'templito:community/util': []
})(this, function (m_module, Backbone, $, _, DropdownButton) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Util = M.Community.View.Util || {};

  /**
   * @class M.Community.View.Util.InPageNavigationBar
   *
   */
  M.Community.View.Util.InPageNavigationBar = Backbone.View.extend({
    tagName: 'nav',
    className: 'inPageNavBar',
    template: M.Template.Community.Util.InPageNavigationBar,

    events : {
      'click .inPageNavItem' : 'handlePageNavClick'
    },

    /*
    *
    * shouldCreateStickyHeader {boolean}: true, will create a sticky header
    * false, will not create a sticky header
    *
    * tabSelectedIndex {int, (undefined, range[0..inPageSections.length-1])}:
    * undefined: no default tab selected
    * int: an index to indicate which tab is selected when page renders
    *
    */
    options: {
      highlightNavOnScroll: true,
      minNumNavItems: 2,
      shouldCreateStickyHeader: false,
      shouldUseMoreDropdown: true,
      tabSelectedIndex: undefined,
    },

    MAX_NUM_IN_PAGE_NAV_SECTIONS: 5,
    // This constant is key to making sure the more dropdown does not get
    // bumped down if section names are long.
    MAX_CHARS_IN_PAGE_NAV_SECTIONS: 62,
    MAX_IN_PAGE_NAV_CHAR_SEPARATION: 2,
    LENGTH_STORE_HOME: 10,
    LENGTH_MORE_DROPDOWN: 4,


    initialize: function() {
      M.required(this.options.inPageSections);
      M.required(this.options.$containerEl);

      if (this.options.inPageSections.length < this.options.minNumNavItems) {
        return;
      }

      this.$el = $(this.el);
      this.$containerEl = this.options.$containerEl;
      this.$containerEl.prepend(this.$el);
      if (this.options.highlightNavOnScroll === true) {
        this._attachScrollHandler();
      }
      if (this.options.shouldCreateStickyHeader === true) {
        this._createStickyNavHeader();
      }
      this.render();
    },

    render: function() {
      this._checkSectionsExist();
      this._checkTabSelected();
      this._removeOverflowingSections();
      this.$el.html(this.template(this.options));
      this._checkRenderDropdown();
      return this;
    },

    _checkSectionsExist: function() {
      var that = this;
      var sections = this.options.inPageSections;
      _.each(sections, function(section){
        if (that._isHTMLElementId(section['sectionId'])) {
          M.assert($(section['sectionId']).length > 0);
        }
      });
    },

    getTabSelectedIndex: function() {
      return this.tabSelectedIndex;
    },

    _checkTabSelected: function() {
      if (this.options.tabSelectedIndex != undefined) {
        M.assert(this.options.tabSelectedIndex <=
          (this.options.inPageSections.length - 1));
        M.assert(this.options.tabSelectedIndex >= 0);
        this.tabSelectedIndex = this.options.tabSelectedIndex;
      }
    },

    _removeOverflowingSections: function() {
      if (this.options.shouldUseMoreDropdown !== true) {
        return false;
      }

      // Total max chars starts with space + STORE HOME + MORE + space
      var excludedNavItemsLength = this.LENGTH_STORE_HOME +
        this.LENGTH_MORE_DROPDOWN + (this.MAX_IN_PAGE_NAV_CHAR_SEPARATION * 2);
      var totalMaxChars = excludedNavItemsLength;

      // Get all sections minus the store home
      var numTotalSections = this.options.inPageSections.length;
      var sections = this.options.inPageSections.slice(1, numTotalSections);

      // Begin adding up the chars of the sections
      var sectionTitleLength = 0;
      // Index starts at 1 to exclude store home section
      var numSectionsInMoreDropdownIndex = 1;

      var that = this;
      _.each(sections, function(section) {
        // We need to account for the space on both sides of each section
        // title.
        sectionTitleLength = section.sectionTitle.length +
          (that.MAX_IN_PAGE_NAV_CHAR_SEPARATION * 2);
        totalMaxChars += sectionTitleLength;

        // Increase the index for number of sections we will put in the
        // more dropdown menu.
        numSectionsInMoreDropdownIndex++;

        if (totalMaxChars > (that.MAX_CHARS_IN_PAGE_NAV_SECTIONS +
            excludedNavItemsLength)) {
          numSectionsInMoreDropdownIndex--;
          return;
        }
      });

      // Do not create the more dropdown if we don't need to.
      var isNavBarMaxCharsExceeded = (totalMaxChars >
        (this.MAX_CHARS_IN_PAGE_NAV_SECTIONS + excludedNavItemsLength));

      // Add remaining items to the more dropdown menu
      if (isNavBarMaxCharsExceeded) {
        var numItemsToRemove = (
          this.options.inPageSections.length - numSectionsInMoreDropdownIndex);
        this.dropdownSections = this.options.inPageSections.splice(numSectionsInMoreDropdownIndex, numItemsToRemove);
      }
    },

    _checkRenderDropdown: function() {
      if (!this.options.shouldUseMoreDropdown ||
          this.dropdownSections === undefined) {
        return false;
      }

      var dropdownListItemInfo = [];
      _.each(this.dropdownSections, function(section){
        dropdownListItemInfo.push({
          "listItemLinkText": section['sectionTitle'],
          "listItemLink": section['sectionId']
        });
      });

      var dropdownButtonView = new M.Community.View.Util.DropdownButton({
        listItemInfo: dropdownListItemInfo,
        parentEl: $('.moreButtonContainer'),
        buttonTextStr: "More",
        hideOnScroll: true,
        isButton: false
      });

      dropdownButtonView.render();
    },

    _attachScrollHandler: function() {
      var that = this;
      // when scrolling occurs, call supporting function that
      // highlights the section that the window view port is in
      $(window).scroll(function() {
        that.highlightNavItem();
      });
    },

    _createStickyNavHeader: function() {
      new M.View.Util.StickyNavHeader ({
        $stickyElement: this.$containerEl
      });
    },

    _scrollToSection: function(evt, sectionId) {
      // prevent the page from jumping to a section
      evt.preventDefault();
      var $clickedNavItem = $(evt.currentTarget);
      var targetPosition = $(sectionId).offset().top - this.$el.innerHeight();
      M.Community.View.Util.Common.scrollToSection(targetPosition);
    },

    _isHTMLElementId: function(value) {
      return ((value != "") && (value != undefined) && (value[0] == '#'));
    },

    handlePageNavClick: function(evt) {
      var url = $(evt.currentTarget).find('a').attr('href');
      if (this._isHTMLElementId(url)) {
        this._scrollToSection(evt, url);
      }
      evt.stopPropagation();
    },

    /** the function iterates through all navigation items to see if
      * their sections are inside the window view port. If a section
      * is in the window, the navigation item will be tagged with active class
      */
    highlightNavItem: function() {
      var windowViewPortCenter
        = $(window).scrollTop() + $(window).innerHeight()/2;
      var $navigationItems = this.$el.find('.inPageNavItem');
      var $activeItem = $('');
      var that = this;

      $navigationItems.each(function() {
        var sectionId = $(this).find('a').attr('href');
        if (that._isHTMLElementId(sectionId)) {
          var $sectionBody = $('body').find(sectionId);
          var sectionBodyOffsetTop = $sectionBody.offset().top;
          var sectionBodyOffsetTopWithOuterHeight = sectionBodyOffsetTop
            + $sectionBody.outerHeight(true);
          // outHeight(true) gets the height of an element including margin
          if ((windowViewPortCenter >= sectionBodyOffsetTop) &&
              (windowViewPortCenter < sectionBodyOffsetTopWithOuterHeight)) {
            $activeItem = $(this);
            return false;
          }
        }
      });

      $navigationItems.removeClass('active');
      $activeItem.addClass('active');
    }

  });

  return { };

});
